import React from 'react';
import { DialogContent } from '@material-ui/core';

interface EeModalContentProps {
  children: React.ReactNode;
}

export const EeModalContent: React.FC<EeModalContentProps> = ({ children }) => {
  return <DialogContent className="lens-body">{children}</DialogContent>;
};
